import React, { useEffect, useState } from 'react'
// import { motion, AnimatePresence } from 'framer-motion'
import localforage from 'localforage'
// import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
// 
// import { Field } from '#page/Auth/components'
// import * as requests from '#src/requests'
import { useRecoilValue } from 'recoil';
import {
  accountState,
} from '../state'


export default function SubscriptionDays(props) {
  // const { t } = useTranslation()
  // const theme = useTheme()
  const account = useRecoilValue(accountState)

  let daysLeft = 0

  if (account === null) return null
  if (account?.isTester) {
    daysLeft = Infinity
  } else if(account?.subStatus){
    const { status, nextPaymentTime } = account?.subStatus
    const now = Date.now()
    if (nextPaymentTime > now) {
      daysLeft = Math.floor((nextPaymentTime - now) / (1000 * 60 * 60 * 24))
    } else {
      daysLeft = 0
    }
  }

  const text = daysLeft > 0 
  ? `Subscription days left: ${daysLeft === Infinity ? '∞' : daysLeft}`
  : 'Subscription is not active'

  return (
    <Box
      elevation={0}
      sx={{
        py: 2,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          {text}
        </Typography>

    </Box>
  )
}

